import { ArrowRight } from "lucide-react";
import { Reveal, MaskLines, Eyebrow } from "./motion";

const PAIRS = [
  ["Empregado", "Empresário"],
  ["Profissional liberal", "Líder de equipa"],
  ["Consultor independente", "Dono do seu negócio"],
  ["Gestor sem suporte", "Membro de uma rede nacional"],
];

export const Transformation = () => (
  <section id="transformacao" data-testid="before-after-container" className="bg-paper py-24 text-ink sm:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Eyebrow num="04">A Transformação</Eyebrow>
      <h2 className="mt-6 font-display text-4xl font-black leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
        <MaskLines lines={["Antes", <span className="text-orange-deep">& Depois.</span>]} />
      </h2>

      <div className="mt-16 border-t border-ink/15">
        <div className="hidden grid-cols-[1fr_auto_1fr] gap-8 py-4 font-mono text-xs uppercase tracking-[0.22em] text-slate-500 md:grid">
          <span>Antes</span><span className="w-12" /><span>Depois</span>
        </div>
        {PAIRS.map(([a, b], i) => (
          <Reveal key={a} delay={i * 0.08}>
            <div data-testid={`transformation-row-${i}`} className="group grid grid-cols-1 items-center gap-2 border-b border-ink/15 py-6 transition-[background-color,padding] duration-500 hover:bg-white md:grid-cols-[1fr_auto_1fr] md:gap-8 md:px-4 md:py-8">
              <span className="font-display text-lg font-semibold text-slate-500 line-through decoration-orange/0 decoration-2 transition-[text-decoration-color] duration-500 group-hover:decoration-orange sm:text-2xl">
                <span className="mr-3 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 no-underline md:hidden">Antes</span>{a}
              </span>
              <span className="hidden h-12 w-12 place-items-center rounded-full border border-ink/15 transition-[background-color,border-color,transform] duration-500 group-hover:translate-x-2 group-hover:border-orange group-hover:bg-orange group-hover:text-white md:grid">
                <ArrowRight className="h-5 w-5" />
              </span>
              <span className="font-display text-2xl font-black tracking-tight sm:text-4xl">
                <span className="mr-3 font-mono text-[11px] font-medium uppercase tracking-[0.2em] text-orange-deep md:hidden">Depois</span>{b}
              </span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-20 grid gap-6 lg:grid-cols-12">
        <p className="text-lg text-slate-600 sm:text-xl lg:col-span-4">O verdadeiro objetivo não é abrir uma loja.</p>
        <p className="font-display text-3xl font-black leading-[1.05] tracking-tight sm:text-5xl lg:col-span-8" data-testid="transformation-statement">
          É criar uma <span className="relative inline-block text-orange-deep">nova versão<svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 12" preserveAspectRatio="none" aria-hidden><path d="M2 9 Q100 -2 198 8" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" /></svg></span> de si próprio.
        </p>
      </Reveal>
    </div>
  </section>
);
